import React from "react";
import img1 from "../../assets/insights/insights1.png";
import img2 from "../../assets/insights/Insights2.png";

const insightsData = [
  {
    img: img1,
    heading:
      "GogiBus Named Boomi’s FY23 APJ Systems Integrator (SI) Partner of the Year…",
  },
  {
    img: img2,
    heading: "GogiBus Partners with SafetyCulture to Enhance…",
  },
  {
    img: img1,
    heading: "Using EdTech to Close Education Gaps",
  },
];

const Insights = () => {
  return (
    <div
      id="insights"
      className="flex dark:bg-dark flex-col py-[100px] gap-[80px] items-center justify-center"
    >
      <div className="text-center relative">
        <h1 className="text-4xl font-extrabold md:text-7xl font-mono text-center text-dark dark:text-white leading-normal">
          Insights
        </h1>
        <div
          className="dark:bg-custom-gradient"
          style={{
            position: "absolute",
            width: "320.95px",
            height: "157.05px",
            left: "50%", // Center horizontally
            top: "50%", // Center vertically
            transform: "translate(-50%, -50%) matrix(1, 0, -0.03, 1, 0, 0)", // Adjust for precise positioning
            opacity: 0.2,
            filter: "blur(34px)",
            borderRadius: "50%",
            zIndex: "0", // Ensure it's behind the text
          }}
        ></div>
      </div>

      <div className="w-full md:w-[90%]  grid grid-cols-1 px-5 sm:grid-cols-2 gap-[50px] lg:grid-cols-3 ">
        {insightsData.map((benefit, index) => (
          <div
            className="flex flex-col sm:h-[500px] justify-start gap-4"
            key={index}
          >
            <div className="flex-grow flex  flex-col gap-5">
              <img
                src={benefit.img}
                className="rounded-lg w-[320px] self-center h-[200px] duration-300 hover:scale-105 cursor-pointer shadow-lg "
                alt=""
              />
              <h1 className="text-[#4f1951] dark:text-light text-3xl font-sans font-semibold">
                {benefit.heading}
              </h1>
            </div>

            <button className="text-[#4f1951] border-[1px] border-[#4f1951] duration-300 hover:scale-110 hover:text-white px-5 py-2 dark:text-light dark:border-light rounded-lg  self-start dark:hover:bg-white  dark:hover:text-[#4f1951] hover:bg-[#4f1951]">
              Read more
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Insights;
